export interface ISubmitCaseClosingData {
    studentSK?: string;
    closeDate?: string;
    reason?: number;
    dischargeReason?: { id?: number };
    dischargeDate?: string;
    dischargeStatus?: { id?: number };
    openOrClose?: string;
    reasonForDelays?: { reasonForDelayId?: number; description?: string }[];
}

export class SubmitCaseClosingModel {
    studentSK: string;
    personSk: string;
    caseactionsk: string;
    caseActionType: number;
    caseCloseDate: string;
    reason: number;
    dischargeReason: number;
    eventType: string;
    dischargeDate: string;
    dischargeStatus: number;
    openOrClose: string;
    reasonforDelays: { reasonForDelayId?: number; description?: string }[];
    constructor(data: Partial<ISubmitCaseClosingData>) {
        this.caseactionsk = null;
        this.caseActionType = 1;
        this.studentSK = data?.studentSK;
        this.caseCloseDate = data?.closeDate;
        this.reason = data?.reason;
        this.dischargeReason = data?.dischargeReason?.id;
        this.dischargeDate = data?.dischargeDate;
        this.dischargeStatus = data?.dischargeStatus?.id
        this.openOrClose = data?.openOrClose;
        this.reasonforDelays = Array.isArray(data?.reasonForDelays) && data.reasonForDelays.length > 0 && data.reasonForDelays[0]?.reasonForDelayId && data.reasonForDelays[0]?.description ? data.reasonForDelays : null;
    }
    get id(): string {
        return this.caseactionsk
    }
}